async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function changeLine(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity })
  });
}

function isGiftItem(item) {
  return item.properties && item.properties._free_gift === "true";
}

async function enforceFreeGiftRules() {
  const cart = await getCart();
  if (!cart || !cart.items) return;

  const giftLines = [];
  let hasNonGift = false;

  cart.items.forEach((item, idx) => {
    const line = idx + 1;
    if (isGiftItem(item)) {
      giftLines.push({ line, qty: item.quantity });
    } else {
      hasNonGift = true;
    }
  });

  // ❌ Remove gift if it’s the only item
  if (!hasNonGift && giftLines.length) {
    await Promise.all(giftLines.map(g => changeLine(g.line, 0)));
    return;
  }

  // ❌ Force gift qty back to 1
  const overQty = giftLines.filter(g => g.qty > 1);
  if (overQty.length) {
    await Promise.all(overQty.map(g => changeLine(g.line, 1)));
  }
}

// Run on load
document.addEventListener('DOMContentLoaded', () => {
  enforceFreeGiftRules();
});

// Re-run when cart drawer opens / updates
document.addEventListener('click', (e) => {
  if (
    e.target.closest('[href*="/cart"]') ||
    e.target.closest('button[name="checkout"]') ||
    e.target.closest('.cart-drawer') ||
    e.target.closest('[aria-controls*="cart"]')
  ) {
    setTimeout(enforceFreeGiftRules, 300);
  }
});

// Block checkout if only gift exists
document.addEventListener('click', async (e) => {
  const checkoutBtn = e.target.closest(
    'button[name="checkout"], a[href*="checkout"]'
  );
  if (!checkoutBtn) return;

  const cart = await getCart();
  const hasPaid = cart.items.some(i => !isGiftItem(i));
  const hasGift = cart.items.some(isGiftItem);

  if (hasGift && !hasPaid) {
    e.preventDefault();
    alert('Free gifts require a qualifying purchase.');
    enforceFreeGiftRules();
  }
});


/* ============================================================================
 * PLAYR ADVERTORIAL CART BRIDGE  (appended)
 *
 * Lives inside this asset on purpose: the advertorial page's content filter
 * strips the 2nd+ consecutive <script> in the body, so a separate bridge
 * script tag gets removed. free-gift-enforcer.js is the FIRST (surviving)
 * script tag, so the bridge rides along here. Self-isolated in its own IIFE.
 *
 *   (1) Free-shaker auto-add when a subscription is in the cart.
 *   (2) Intercept [data-playr-form] tier submits -> AJAX /cart/add.js ->
 *       refresh the Horizon cart drawer sections -> open the slide-out drawer.
 * ========================================================================== */
(function () {
  'use strict';

  var SHAKER_VARIANT_ID = 47304416526571;
  var SHAKER_HANDLE = 'free-shaker-with-first-order';
  var ATTEMPT_KEY = 'playr:shakerAutoAddAttempts';
  var MAX_ATTEMPTS_PER_SESSION = 3;
  var adding = false;

  function getAttempts() {
    try { return parseInt(sessionStorage.getItem(ATTEMPT_KEY) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpAttempts() {
    try { sessionStorage.setItem(ATTEMPT_KEY, String(getAttempts() + 1)); } catch (e) {}
  }
  function resetAttempts() {
    try { sessionStorage.setItem(ATTEMPT_KEY, '0'); } catch (e) {}
  }

  function addShakerIfNeeded() {
    if (adding) return Promise.resolve(false);
    if (getAttempts() >= MAX_ATTEMPTS_PER_SESSION) return Promise.resolve(false);
    adding = true;
    return fetch('/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('cart.js failed'); return r.json(); })
      .then(function (cart) {
        var hasSub = false, hasShaker = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].selling_plan_allocation) hasSub = true;
          if (cart.items[i].handle === SHAKER_HANDLE) hasShaker = true;
        }
        if (hasSub && !hasShaker) {
          bumpAttempts();
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: SHAKER_VARIANT_ID, quantity: 1 }] })
          }).then(function (r) { return r.ok; });
        }
        return false;
      })
      .catch(function () { return false; })
      .finally(function () { adding = false; });
  }

  var STYLE_ID = 'playr-ppp-drawer-fix';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '#header-group{display:block !important;height:0 !important;min-height:0 !important;overflow:visible !important;visibility:visible !important;}'
      /* PLAYR-DRAWER-FIX-v4: collapse header chain WITHOUT display:none on any ancestor of cart-drawer-component */
      + '#header-group > .shopify-section:not(.cart-drawer-section),#header-group .header-section,#header-group header-component.header,#header-group .header{display:block !important;height:0 !important;min-height:0 !important;max-height:0 !important;overflow:visible !important;visibility:visible !important;padding:0 !important;margin:0 !important;border:0 !important;}'
      + '#header-group .header__row,#header-group .header__columns,#header-group .header__column:not(.header__column--right),#header-group .announcement-bar__content{height:0 !important;max-height:0 !important;overflow:hidden !important;visibility:hidden !important;padding:0 !important;margin:0 !important;}'
      + '#header-group .announcement-bar{display:none !important;}'
      + '#header-group header-actions,#header-group .header__column--right,#header-group cart-drawer-component{height:auto !important;max-height:none !important;overflow:visible !important;visibility:visible !important;}'
      + 'cart-drawer-component,.cart-drawer{display:block !important;visibility:visible !important;height:auto !important;overflow:visible !important;}'
      + 'cart-drawer-component > [data-testid="cart-drawer-trigger"],.cart-drawer > .header-actions__action{display:none !important;}'
      + 'dialog.cart-drawer__dialog,.cart-drawer__dialog{position:fixed !important;inset:0 0 0 auto !important;z-index:2147483000 !important;width:min(420px,92vw) !important;max-width:92vw !important;height:100dvh !important;max-height:100dvh !important;margin:0 !important;}'
      + 'dialog.cart-drawer__dialog:not([open]),.cart-drawer__dialog:not([open]){display:none !important;}'
      + 'dialog.cart-drawer__dialog[open],.cart-drawer__dialog[open]{display:flex !important;flex-direction:column !important;visibility:visible !important;}'
      + 'dialog.cart-drawer__dialog[open]::backdrop,.cart-drawer__dialog[open]::backdrop{background:rgba(15,23,42,0.5) !important;}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function getComp() { return document.querySelector('cart-drawer-component'); }
  function getDialog() {
    return document.querySelector('dialog.cart-drawer__dialog, .cart-drawer__dialog, cart-drawer-component dialog');
  }

  function refreshDrawerSections() {
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });
    if (!sectionIds.length) {
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })); } catch (e) {}
      return Promise.resolve();
    }
    var url = '/?sections=' + encodeURIComponent(sectionIds.join(',')) + '&sections_url=' + encodeURIComponent(window.location.pathname);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'playr-advertorial-bridge', data: { sections: sections } }
          }));
        } catch (e) {}
      })
      .catch(function () {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })); } catch (e) {}
      });
  }

  function openDrawer() {
    injectStyle();
    var comp = getComp();
    if (comp && typeof comp.open === 'function') {
      try { comp.open(); var d0 = getDialog(); if (d0 && d0.open) return true; } catch (e) {}
    }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"], cart-drawer-component summary, [aria-controls*="cart-drawer"]');
    if (trig) {
      try { trig.click(); var d1 = getDialog(); if (d1 && d1.open) return true; } catch (e) {}
    }
    var dlg = getDialog();
    if (dlg) {
      try {
        if (dlg.open) { try { dlg.close(); } catch (e2) {} }
        if (typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
        dlg.setAttribute('open', '');
        if (typeof dlg.show === 'function') dlg.show();
        return true;
      } catch (e) {}
    }
    return false;
  }
  window.PLAYR_openCartDrawer = openDrawer;

  function setBtn(form, state, msg) {
    var btn = form.querySelector('[data-playr-cta]') || form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-cta-label]');
    if (!label) return;
    if (state === 'loading') {
      if (!label.hasAttribute('data-orig')) label.setAttribute('data-orig', label.textContent);
      label.textContent = 'Adding\u2026';
      if (btn) btn.classList.add('is-loading');
    } else if (state === 'added') {
      label.textContent = '\u2713 Added';
      if (btn) btn.classList.remove('is-loading');
    } else if (state === 'error') {
      label.textContent = msg || 'Sold out';
      if (btn) btn.classList.remove('is-loading');
    } else {
      if (label.hasAttribute('data-orig')) label.textContent = label.getAttribute('data-orig');
      if (btn) btn.classList.remove('is-loading');
    }
  }

  function rawAdd(variantId, sellingPlanId, quantity) {
    var item = { id: variantId, quantity: quantity || 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    });
  }

  function bindForms() {
    var forms = document.querySelectorAll('[data-playr-form]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.dataset.pppBound === '1') return;
        form.dataset.pppBound = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (form.dataset.pppBusy === '1') return;
          form.dataset.pppBusy = '1';
          setBtn(form, 'loading');

          var idEl = form.querySelector('[name="id"]');
          var spEl = form.querySelector('[name="selling_plan"]');
          var qtyEl = form.querySelector('[name="quantity"]');
          var variantId = idEl ? idEl.value : null;
          var sellingPlanId = (spEl && spEl.value) ? spEl.value : null;
          var quantity = (qtyEl && parseInt(qtyEl.value, 10)) ? parseInt(qtyEl.value, 10) : 1;

          if (!variantId) {
            setBtn(form, 'error', 'Unavailable');
            form.dataset.pppBusy = '';
            setTimeout(function () { setBtn(form, 'reset'); }, 2400);
            return;
          }

          resetAttempts();

          rawAdd(variantId, sellingPlanId, quantity).then(function (r) {
            if (r && r.ok === false) {
              var m = (r.data && (r.data.description || r.data.message)) || 'Sold out';
              setBtn(form, 'error', m);
              form.dataset.pppBusy = '';
              setTimeout(function () { setBtn(form, 'reset'); }, 2600);
              return;
            }
            setBtn(form, 'added');
            var post = sellingPlanId ? addShakerIfNeeded() : Promise.resolve(false);
            post.then(function () {
              return refreshDrawerSections();
            }).then(function () {
              var opened = openDrawer();
              if (!opened) { window.location.href = '/cart'; return; }
              form.dataset.pppBusy = '';
              setTimeout(function () { setBtn(form, 'reset'); }, 1600);
            });
          }).catch(function () {
            form.dataset.pppBusy = '';
            try { form.submit(); } catch (e) { window.location.href = '/cart'; }
          });
        });
      })(forms[i]);
    }
  }

  function boot() {
    addShakerIfNeeded();
    try {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.target && m.target.tagName === 'DIALOG' && m.target.hasAttribute('open')) {
            setTimeout(addShakerIfNeeded, 400);
            break;
          }
        }
      });
      observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
    } catch (e) {}

    if (document.querySelector('[data-playr-root]')) {
      injectStyle();
      bindForms();
      try {
        var mo = new MutationObserver(bindForms);
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
